export default __webpack_public_path__ + "static/media/drivers-mqtt.e5773303.yaml";